import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "content-container"
};
const _hoisted_2 = {
  key: 0
};
import store from '@/store';
import { computed, nextTick, onMounted, ref } from 'vue';
import _ from 'lodash';
import { ElSelect, ElButton, ElInput } from 'element-plus';
import { Goods, Sort, SortDown, SortUp, Wallet } from '@element-plus/icons-vue';
export default {
  __name: 'MarketPropsHeader',
  props: {
    hasSort: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  emits: ['updateFilter', 'updateMode'],

  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const marketSortOptions = [{
      'id': 1,
      'desc': '价格',
      'value': 'price'
    }, {
      'id': 2,
      'desc': '稀有度',
      'value': 'rare_level'
    }];
    const recordsSortOptions = [{
      'id': 1,
      'desc': '时间',
      'value': 'update_time'
    }, {
      'id': 2,
      'desc': '数额',
      'value': 'order_price'
    }];
    const sortIconList = [Sort, SortUp, SortDown]; // refs

    const isMarket = ref(true);
    const selectSort = ref(null);
    const sortMode = ref(0);
    const selectChannel = ref(null);
    const selectType = ref(null);
    const selectTag = ref(null);
    const search = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const propsTypes = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_types ?? [];
    });
    const propsTags = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.props_tags ?? [];
    });
    const marketChannels = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.market_channels ?? [];
    });
    const sortIcon = computed(() => {
      return sortIconList[sortMode.value];
    }); // functions

    const getData = () => {
      if (propsTypes.value.length === 0) {
        store.dispatch('get_props_types');
      }

      if (propsTags.value.length === 0) {
        store.dispatch('get_props_tags');
      }

      if (marketChannels.value.length === 0) {
        store.dispatch('get_market_channels');
      }
    };

    const changeMode = () => {
      isMarket.value = !isMarket.value;
      emits('updateMode', isMarket.value);
    };

    const searchProps = () => {
      let filterInfo = { ...(selectType.value && {
          'select_type': selectType.value
        }),
        ...(selectTag.value && {
          'select_tag': selectTag.value
        }),
        ...(selectChannel.value && {
          'select_channel': selectChannel.value
        }),
        ...(search.value && search.value.trim() !== '' && {
          'search': search.value
        })
      };

      if (selectSort.value && sortMode.value) {
        let sorter_key = selectSort.value;
        let sorter_reverse = 'ASC';
        if (sortMode.value === 2) sorter_reverse = 'DESC';
        filterInfo['select_sort'] = `${sorter_key};${sorter_reverse}`;
      } // console.log('searchProps', JSON.stringify(filterInfo))


      nextTick(() => {
        emits('updateFilter', filterInfo);
      });
    };

    const onSelectFilterChange = _.debounce(searchProps, 300);

    const onInputFilterChange = _.debounce(searchProps, 300);

    const onSortChange = _.debounce(() => {
      if (selectSort.value && sortMode.value === 0) {
        sortMode.value = 1;
      } else if (!selectSort.value && sortMode.value !== 0) {
        sortMode.value = 0;
      }

      searchProps();
    }, 300);

    const onSortModeChange = _.debounce(() => {
      if (selectSort.value) {
        sortMode.value = sortMode.value === 1 ? 2 : 1;
        searchProps();
      }
    }, 300); // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_option = _resolveComponent("el-option");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "title",
        onClick: changeMode
      }, [worldOutlook.value ? (_openBlock(), _createElementBlock("text", _hoisted_2, _toDisplayString(worldOutlook.value.name) + "  /  ", 1)) : _createCommentVNode("", true), _createVNode(_component_el_icon, {
        size: 16,
        style: {
          "margin": "0 8px"
        }
      }, {
        default: _withCtx(() => [isMarket.value ? (_openBlock(), _createBlock(_unref(Goods), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(Wallet), {
          key: 1
        }))]),
        _: 1
      }), _createElementVNode("text", null, _toDisplayString(isMarket.value ? '商品列表' : '购买记录'), 1)]), _cache[5] || (_cache[5] = _createElementVNode("div", {
        style: {
          "flex": "1"
        }
      }, null, -1)), __props.hasSort ? (_openBlock(), _createBlock(_unref(ElSelect), {
        key: 0,
        modelValue: selectSort.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectSort.value = $event),
        "show-arrow": false,
        clearable: "",
        placeholder: "排序依据",
        "popper-class": "commonPopper",
        class: _normalizeClass(selectSort.value ? 'selected-selector sort-selector' : 'sort-selector'),
        onChange: _unref(onSortChange)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isMarket.value ? marketSortOptions : recordsSortOptions, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.desc,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "class", "onChange"])) : _createCommentVNode("", true), __props.hasSort ? (_openBlock(), _createBlock(_unref(ElButton), {
        key: 1,
        class: _normalizeClass([sortMode.value !== 0 ? 'is-active' : '']),
        icon: sortIcon.value,
        onClick: _unref(onSortModeChange)
      }, null, 8, ["class", "icon", "onClick"])) : _createCommentVNode("", true), marketChannels.value.length > 1 && isMarket.value ? (_openBlock(), _createBlock(_unref(ElSelect), {
        key: 2,
        modelValue: selectChannel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectChannel.value = $event),
        "show-arrow": false,
        clearable: "",
        placeholder: "渠道筛选",
        "popper-class": "commonPopper",
        class: _normalizeClass(selectChannel.value ? 'selected-selector' : ''),
        onChange: _unref(onSelectFilterChange)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marketChannels.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "class", "onChange"])) : _createCommentVNode("", true), isMarket.value ? (_openBlock(), _createBlock(_unref(ElSelect), {
        key: 3,
        modelValue: selectType.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => selectType.value = $event),
        "show-arrow": false,
        clearable: "",
        placeholder: "类别筛选",
        "popper-class": "commonPopper",
        class: _normalizeClass(selectType.value ? 'selected-selector' : ''),
        onChange: _unref(onSelectFilterChange)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsTypes.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.desc,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "class", "onChange"])) : _createCommentVNode("", true), isMarket.value ? (_openBlock(), _createBlock(_unref(ElSelect), {
        key: 4,
        modelValue: selectTag.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectTag.value = $event),
        "show-arrow": false,
        clearable: "",
        placeholder: "标签筛选",
        "popper-class": "commonPopper",
        class: _normalizeClass(selectTag.value ? 'selected-selector' : ''),
        onChange: _unref(onSelectFilterChange)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(propsTags.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.desc,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "class", "onChange"])) : _createCommentVNode("", true), _createVNode(_unref(ElInput), {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => search.value = $event),
        maxlength: "16",
        type: "text",
        placeholder: "查找商品",
        onInput: _unref(onInputFilterChange)
      }, null, 8, ["modelValue", "onInput"])]);
    };
  }

};